import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const useScrollRestoration = (key: string) => {
    const location = useLocation();

    // Only restore, not save!
    useEffect(() => {
        const pos = sessionStorage.getItem(key);
        if (pos) {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    window.scrollTo(0, parseInt(pos, 10));
                }, 50); // wait a bit
            });
        }
    }, [location.key, key]);
};